module.exports = __webpack_public_path__ + "static/media/charles04.9db7513b.jpg";